import type {BaseControlledListItem} from '@Components/controlled-list/controlled-list.types';

export interface ControlledListSeasonalItemProps extends BaseControlledListItem {
  seasonType: ControlledListSeasonalItemType;
  showSelectionCheckmark?: boolean;
  isDisabled?: boolean;
  textClassName?: string;
}

export enum ControlledListSeasonalItemType {
  HALLOWEEN = 'halloween',
  CHRISTMAS = 'christmas',
}